import React from "react";
import {Row,Col} from "shards-react";
import placeholder from '../../images/placeholder.svg';


const FileUpload = ({fileType,imageSrc,onFileUpload,itemField}) => (
  
  <Row>
    <Col xs="2">
    {fileType==='IMAGE' ?
     <img src={(imageSrc!=="" && imageSrc!=undefined )? imageSrc : placeholder} className="upload-image" alt="display" />
     : 
     imageSrc!=undefined ?    <label><a href={imageSrc} className="" download="download">Download Here</a></label>  :  <label>Uploaded File<br/>for link</label>}
     </Col>
    <Col xs="10">
    <div className="custom-file mb-3">
    <input type="file" className="custom-file-input" id="customFile2" multiple="multiple" onChange={(e)=>onFileUpload(e,itemField)} />
    <label className="custom-file-label" htmlFor="customFile2">Choose file...</label>
    </div>
    </Col>
  </Row>

  
);

export default FileUpload;
